import { render, staticRenderFns } from "./AuthorAboutBox.vue?vue&type=template&id=1200eb4e"
import script from "./AuthorAboutBox.vue?vue&type=script&lang=js"
export * from "./AuthorAboutBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports